import * as React from 'react';
export const sequraSvg = React.forwardRef(function sequraSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.333 13.262a5.811 5.811 0 0 1-1.468-.243c-.053-.018-.075-.084-.036-.125a7.434 7.434 0 0 0 1.7-3.292 7.27 7.27 0 0 0-.733-5.126 7.688 7.688 0 0 0-3.999-3.447A8.056 8.056 0 0 0 5.44.893a7.74 7.74 0 0 0-4.18 3.243 7.3 7.3 0 0 0-1.01 5.08 7.466 7.466 0 0 0 2.643 4.505A7.97 7.97 0 0 0 7.722 15.5h.015a.486.486 0 0 0 .487-.49v-1.272c0-.26-.212-.47-.48-.48a5.618 5.618 0 0 1-3.35-1.247 5.24 5.24 0 0 1-1.855-3.16 5.126 5.126 0 0 1 .705-3.565A5.428 5.428 0 0 1 6.176 3.01a5.67 5.67 0 0 1 3.766.094 5.4 5.4 0 0 1 2.806 2.422 5.095 5.095 0 0 1 .516 3.593 5.237 5.237 0 0 1-1.475 2.6c-.022.02-.115.02-.14 0a5.255 5.255 0 0 1-1.184-1.706 5.078 5.078 0 0 1-.412-1.835.488.488 0 0 0-.494-.466H8.238a.531.531 0 0 0-.337.115.462.462 0 0 0-.168.368c.025.92.222 1.821.59 2.676a7.44 7.44 0 0 0 1.687 2.433 7.796 7.796 0 0 0 2.524 1.626 7.982 7.982 0 0 0 2.774.57h.014a.476.476 0 0 0 .483-.487v-1.271c0-.261-.21-.47-.48-.48',
    }),
  );
});
sequraSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var sequra = {
  category: 'paymentmethod',
  colorable: true,
  name: 'sequra',
  svg: sequraSvg,
};
